<script setup lang="ts">
import { MtdButton, MtdField, MtdModalMobile, MtdTypography } from '@paygine/mtd-uikit'
import { storeToRefs } from 'pinia'
import { computed, ref } from 'vue'

import { userDataModel } from '@/entities/user-data'
import { useModel } from '@/pages/tollroads_enroll_page/model'
import { AttentionIcon } from '@/shared/icons'
import { dateFromTimestamp, formatPhone } from '@/shared/lib/formatting'
import { VPayMethod } from '@/shared/ui'
import { TransportManagement } from '@/widgets/transport-management'

import ErrorSelectBank from './ErrorSelectBank.vue'

const isError = ref(false)

const store = userDataModel.useModel()
const { userData } = storeToRefs(store)

const { changeStatusSubscription, isLoading } = useModel()

const isCancelModalOpen = ref(false)
const isRenewModalOpen = ref(false)

const isSubscriptionActive = computed(() => userData.value?.payment_methods?.sbp[0]?.is_active)

async function deactivateSubscription() {
    if (!userData.value?.payment_methods.sbp[0]?.id) return

    const res = await changeStatusSubscription(userData.value?.payment_methods.sbp[0]?.id, false)

    if (res && userData.value?.payment_methods?.sbp[0]) {
        userData.value.payment_methods.sbp[0].is_active = false
        isCancelModalOpen.value = false
    }
}

async function renewSubcription() {
    if (!userData.value?.payment_methods.sbp[0]?.id) return

    const res = await changeStatusSubscription(userData.value?.payment_methods.sbp[0]?.id, true)

    if (res && userData.value?.payment_methods?.sbp[0]) {
        userData.value.payment_methods.sbp[0].is_active = true
        isRenewModalOpen.value = false
    }
}
</script>

<template>
    <MtdTypography
        variant="header-2"
        class="default-layout__title"
        tag="h1"
        >Управление подпиской
    </MtdTypography>

    <MtdTypography
        v-if="userData?.creation_date"
        tag="p"
        variant="body-2"
        class="default-layout__subtitle"
        >Подключено {{ dateFromTimestamp(userData?.creation_date) }}</MtdTypography
    >

    <form
        action=""
        class="sub-management__form mt-24"
    >
        <MtdField
            v-if="userData?.phone"
            class="sub-management__phone"
            label="Номер телефона"
            disabled
            :model-value="formatPhone(userData?.phone)"
        />

        <TransportManagement
            :transport-list="userData?.grn_list"
            class="mt-32"
        />

        <div class="sub-management__pay-methods">
            <MtdTypography
                variant="subheader-1"
                tag="h2"
                >Способ оплаты
            </MtdTypography>

            <VPayMethod
                v-if="userData?.payment_methods?.sbp?.[0]"
                class="mt-8"
                :can-edit="false"
                :bank="userData?.payment_methods?.sbp?.[0]"
            />
        </div>

        <ErrorSelectBank v-if="isError" />

        <MtdButton
            v-if="isSubscriptionActive"
            variant="danger-secondary"
            class="sub-management__cancel-button"
            type="button"
            :is-loading="isLoading"
            @click="isCancelModalOpen = true"
        >
            Отменить подписку</MtdButton
        >

        <MtdTypography
            v-else
            class="sub-management__inactive-title"
            tag="p"
            variant="body-2"
            >Подписка неактивна</MtdTypography
        >

        <MtdButton
            v-if="!isSubscriptionActive"
            type="button"
            @click="isRenewModalOpen = true"
            >Возобновить подписку</MtdButton
        >

        <MtdModalMobile
            v-model="isRenewModalOpen"
            container-class="sub-management__renew-modal-content"
        >
            <template #content>
                <MtdTypography
                    variant="header-1"
                    class="default-layout__title mt-16"
                    tag="h1"
                    >Выберите способ оплаты
                </MtdTypography>

                <VPayMethod
                    v-if="userData?.payment_methods?.sbp?.[0]"
                    class="mt-16"
                    :can-edit="false"
                    :bank="userData?.payment_methods?.sbp?.[0]"
                    checked
                />

                <MtdButton
                    type="button"
                    class="mt-20"
                    :is-loading="isLoading"
                    @click="renewSubcription"
                    >Возобновить подписку</MtdButton
                >
            </template>
        </MtdModalMobile>

        <MtdModalMobile
            v-model="isCancelModalOpen"
            container-class="sub-management__cancel-modal-content"
        >
            <template #content>
                <AttentionIcon />

                <MtdTypography
                    variant="header-1"
                    class="default-layout__title mt-16"
                    tag="h1"
                    >Отменить подписку?
                </MtdTypography>

                <MtdTypography
                    tag="p"
                    variant="body-2"
                    class="default-layout__subtitle"
                    >Вы потеряете возможность автосписания денежных средств за использование платных
                    дорог</MtdTypography
                >

                <div class="button-container">
                    <MtdButton
                        type="button"
                        variant="main-secondary"
                        @click="isCancelModalOpen = false"
                        >Назад</MtdButton
                    >
                    <MtdButton
                        type="button"
                        variant="danger-secondary"
                        :is-loading="isLoading"
                        @click="deactivateSubscription"
                        >Отменить</MtdButton
                    >
                </div>
            </template>
        </MtdModalMobile>
    </form>
</template>

<style src="./VSubscriptionManagement.scss" scoped lang="scss"></style>
